module.exports = __webpack_public_path__ + "895205e22ad7d4d866df7102352077cd.woff2";